"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelExchanges = void 0;
var utils_1 = require("../../utils");
exports.cancelExchanges = function (axios) {
    return {
        // 취소교환 신청
        postCancelExchanges: function (request) {
            return axios.post('/cancel-exchanges', request.data);
        },
        // 취소교환 신청
        postCancelExchangesV2: function (request) {
            return axios.post('/cancel-exchanges', request.data);
        },
        /** @deprecated postCancelExchangesPredictV2 사용해주세요 */
        postCancelExchangesPredict: function (request) {
            return axios.post('/cancel-exchanges/predict', request.data);
        },
        // 취소교환 예상금액을 계산
        postCancelExchangesPredictV2: function (request) {
            return axios.post('/cancel-exchanges/predict', request.data);
        },
        // 취소교환 수정
        putCancelExchangesNo: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}', request);
            return axios.put(url, request.data);
        },
        // 이미출고
        putCancelExchangesNoAlreadyDelivery: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}/already-delivery', request);
            return axios.put(url, request.data);
        },
        // 취소교환 승인
        putCancelExchangesNoApprove: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}/approve', request);
            return axios.put(url);
        },
        // 취소교환 현금 환불 처리
        putCancelExchangesNoCashRefund: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}/cash-refund', request);
            var config = {
                headers: __assign({}, request.headers)
            };
            return axios.put(url, request.data, config);
        },
        // 취소교환 이미 출고 가능 여부 체크
        getCancelExchangesNoCheckAlreadyDelivery: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}/check-already-delivery', request);
            return axios.get(url);
        },
        /**  @deprecated putCancelExchangesNoConfirmDeposit 사용해주세요 */
        putCancelExchangesNoCongirmDeposit: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}/confirm-deposit', request);
            return axios.put(url, request.data);
        },
        // 취소교환 추가결제 입금확인
        putCancelExchangesNoConfirmDeposit: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}/confirm-deposit', request);
            return axios.put(url, request.data);
        },
        // 취소교환을 변경할 경우 예상금액을 계산
        postCancelExchangesNoPredict: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}/predict', request);
            return axios.post(url, request.data);
        },
        // 취소교환 철회
        putCancelExchangesNoWithdraw: function (request) {
            var url = utils_1.paramPathchange('/cancel-exchanges/{no}/withdraw', request);
            return axios.put(url);
        }
    };
};
